import { Injectable } from '@angular/core';
import { HttpClient, HttpContext } from '@angular/common/http';
import { SiteReqDto } from '../_dtos/siteReqDto';
import { map, Observable, of } from 'rxjs';
import { environment } from '../../environments/environment';
import { SiteResDto } from '../_dtos/siteResDto';
import { SkipLoading } from '../_interceptors/loading.interceptor';
import { EditResourceReqDto } from '../_dtos/editResourceReqDto';
import { UserResDto } from '../_dtos/userResDto';

@Injectable({
  providedIn: 'root',
})
export class SitesService {
  private uri = environment.backendBaseUrl + '/sites';
  private generalUri = environment.backendBaseUrl + '/general/sites';

  private readonly skipLoaderContext = new HttpContext();

  constructor(private http: HttpClient) {
    this.skipLoaderContext = new HttpContext().set(SkipLoading, true);
  }

  createSharepoint(sharepointData: SiteReqDto): Observable<SiteResDto> {
    return this.http.post<SiteResDto>(this.uri, sharepointData, {
      context: this.skipLoaderContext,
    });
  }

  updateSharepoint(
    id: string,
    editResourceData: EditResourceReqDto,
  ): Observable<void> {
    const uri = this.uri + '/' + id;
    return this.http.patch<void>(uri, editResourceData);
  }

  deleteSharepoint(id: string) {
    const uri = this.uri + '/' + id;
    return this.http.delete<void>(uri);
  }

  searchSiteOwner(value: string, id: string): Observable<UserResDto[]> {
    if (!value.trim()) {
      return of([]);
    }

    const sanitizedValue = this.sanitizeSearchInput(value.trim()).toLowerCase();

    const url = `${this.generalUri}/${id}/owners`;

    return this.http
      .get<{ owners: UserResDto[] }>(url, { context: this.skipLoaderContext })
      .pipe(
        map((response) => {
          const owners = response.owners || [];
          return owners.filter((owner) => {
            return (
              owner.displayName?.toLowerCase().startsWith(sanitizedValue) ||
              owner.userPrincipalName
                ?.toLowerCase()
                .startsWith(sanitizedValue) ||
              owner.mailNickname?.toLowerCase().startsWith(sanitizedValue) ||
              owner.givenName?.toLowerCase().startsWith(sanitizedValue)
            );
          });
        }),
      );
  }

  private sanitizeSearchInput(input: string): string {
    return input.replace(/'/g, "''");
  }
}
